module.exports = __webpack_public_path__ + "pc/img/award2020_01.18acca6e.png";